import { IArticleResponse } from "../../../model/base/response/article-response";

export enum ACTION_TYPES {
    SET_ARTICLE = 'SET_ARTICLE',
    SET_LOADING = 'SET_LOADING',
    SET_ERROR = 'SET_ERROR'
}

export interface ICustomPageState {
    article: IArticleResponse | null;
    loading: boolean;
    error: string | null;
}

export const initialState: ICustomPageState = {
    article: null,
    loading: true,
    error: null
};

export type Action =
    | { type: ACTION_TYPES.SET_ARTICLE; payload: IArticleResponse }
    | { type: ACTION_TYPES.SET_LOADING; payload: boolean }
    | { type: ACTION_TYPES.SET_ERROR; payload: string };

export const customPageReducer = (state: ICustomPageState, action: Action): ICustomPageState => {
    switch (action.type) {
        case ACTION_TYPES.SET_ARTICLE:
            return { ...state, article: action.payload, loading: false, error: null };
        case ACTION_TYPES.SET_LOADING:
            return { ...state, loading: action.payload };
        case ACTION_TYPES.SET_ERROR:
            return { ...state, error: action.payload, loading: false };
        default:
            throw new Error(`Unhandled action type`);
    }
};
